import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar"
export default class extends Controller {
  static targets = ["smallScreenNavbar", "menuButton"]

  connect() {
    // Close menu when clicking outside
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    // Close menu on escape key
    this.handleEscape = this.handleEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
    document.removeEventListener('keydown', this.handleEscape)
  }

  toggleSmallScreenNavbar() {
    if (this.smallScreenNavbarTarget.classList.contains("hidden")) {
      this.openSlidebar()
    } else {
      this.closeSlideBar()
    }
  }

  closeSlideBar() {
    this.smallScreenNavbarTarget.classList.add("hidden")
    if (this.hasMenuButtonTarget) {
      this.menuButtonTarget.setAttribute('aria-expanded', 'false')
    }
    document.removeEventListener('click', this.handleOutsideClick)
    document.removeEventListener('keydown', this.handleEscape)
  }

  openSlidebar() {
    this.smallScreenNavbarTarget.classList.remove("hidden")
    if (this.hasMenuButtonTarget) {
      this.menuButtonTarget.setAttribute('aria-expanded', 'true')
    }
    // Add event listeners after a small delay to prevent immediate triggering
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
      document.addEventListener('keydown', this.handleEscape)
    }, 100)
  }

  handleOutsideClick(event) {
    // Close menu if click is outside navbar
    if (!this.element.contains(event.target)) {
      this.closeSlideBar()
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.closeSlideBar()
    }
  }
}
